import React from "react";

export default function Favorites() {
  return <div className="text-white">this is fav</div>;
}
